import { supabase } from '../lib/supabase'

const CLIENT_WEBSITE_STORAGE_KEY = 'lawboost:clientWebsite'

const getStoredClientWebsite = () => {
  try {
    return localStorage.getItem(CLIENT_WEBSITE_STORAGE_KEY)
  } catch (error) {
    console.warn('Unable to read stored client website.', error)
    return null
  }
}

const clearStoredClientWebsite = () => {
  try {
    localStorage.removeItem(CLIENT_WEBSITE_STORAGE_KEY)
  } catch (error) {
    console.warn('Unable to clear stored client website.', error)
  }
}

const clientWebsite = getStoredClientWebsite()

if (clientWebsite) {
  const applyClientWebsite = async () => {
    const { data, error } = await supabase.auth.getUser()
    if (error) {
      console.warn('Unable to load user for client website assignment.', error)
      return
    }

    const user = data?.user
    if (!user) return

    if (user.user_metadata?.clientWebsite === clientWebsite) {
      clearStoredClientWebsite()
      return
    }

    const { error: updateError } = await supabase.auth.updateUser({ data: { clientWebsite } })
    if (updateError) {
      console.warn('Unable to save client website to user metadata.', updateError)
      return
    }

    clearStoredClientWebsite()
  }

  applyClientWebsite()
}
